module.exports = __webpack_public_path__ + "assets/images/default-multi-story.9eca11289b86edccc827e54d949d016b.svg";